<template>
  <div>
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{nickname}}
          </a>
          <a href="javascript:void(0)" @click="logout" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a href="/cgList" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/lwList">上传作品</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>

        <!-- <a class="uploadfile" href="/bmcs">上传作品</a> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="w1200">
        <div>
          <img src="../assets/images/list_cg.png" />
          <a href="/lwList" hover="hand">
            <img src="../assets/images/list_lw_h.png" />
          </a>
          <a href="/upLoadcg" hover="hand">
            <span class="new">+ 新建作品</span>
          </a>
        </div>
        <div id="content" class="bg">
          
          <ul>
            <li class="li_top">
                 <label class="fleft n20">作品类型</label>
              <label class="fleft n25">作品名称</label>
              <label class="fleft n20">状态</label>
              <label class="fleft n20">操作</label>
            </li>
            <li class="li_content" v-for="item in userinfo" >
              <label class="fleft n20" >课改成果展评</label>
              <label class="fleft n25">{{item.worksname}}</label>
              <label class="fleft n20" v-if="item.prize == 5">待评审</label>
              <!-- <label class="fleft brone n20"  v-if="item.prize == 4">优秀奖</label>
              <label class="fleft brone n20"  v-if="item.prize == 3">特等奖</label>
              <label class="fleft brone n20"  v-if="item.prize == 2">二等奖</label>
              <label class="fleft brone n20"  v-if="item.prize == 1">一等奖</label>
              <label class="fleft brone n20"  v-if="item.prize == 0">未获奖</label> -->
              <label class="fleft brone n20" v-if="item.prize == 5">
                <el-button type="primary" size="small" @click="xiugaiWorks(item.wid)">修改作品</el-button>
              </label>
              <label class="fleft brone n20" v-if="item.jiangxiang != 5"></label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="footer"
      style="background:url(('../../assets/images/foot.png')) top center no-repeat;"
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>语文网版权所有 未经书面授权 不得复制或建立镜像 晋公网安备14010902000073号</p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none;"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
import { GetCgzpList} from "@/request/api";
export default {
  data() {
    return {
      userinfo: [],
	  nickname: null,
	  username: null
    };
  },
  created() {
	  var that = this;
    console.log(111111111111);
  var openid = sessionStorage.getItem("openid");
	that.username = sessionStorage.getItem("username");
    if (openid == null) {
      this.$router.push({ path: "/" });
  }
  console.log("username:"+that.username)
	if (that.username == 0) {
        that.$router.push({ path: "/userHome" });
      }
    this.nickname = sessionStorage.getItem("nickname");
  },
  methods: {

    getGaojianList() {
      var userId = sessionStorage.getItem("userId");
      let _this = this;
      if (userId != null) {
      GetCgzpList({ userid: userId }).then(function(response) {
            console.log("#####:"+response.data.states);
            if(response.data.states == 1){
                _this.userinfo = response.data.data;
            } else {
              
            }
           
          })
          .catch(function(reason) {
            alert("error");
          });
      }
    },
  logout(){
    sessionStorage.clear();
     this.$router.push({ path: "/" });
  },
  xiugaiWorks(val){
     this.$router.push({ path:'/xgLoadcg?wid='+val+''  });
  }

  },
  mounted() {
    this.getGaojianList();
  }
};
</script>
